import React from 'react'

import PlaceLoader from './_load/PlaceLoader'
import { usePlace } from './_load/PlaceLoader'
import PlacePresenter from './PlacePresenter'

const PlacePresenterFromId = ({ ...props }) => {
  const place = usePlace()

  return <PlacePresenter place={place} {...props} />
}

const Wrapper = ({ id, ...props }) => {
  return (
    <PlaceLoader id={id}>
      <PlacePresenterFromId {...props} />
    </PlaceLoader>
  )
}

export default Wrapper
